/* unplugin-vue-components disabled */import { render } from "./AvailabilityInfo.vue?vue&type=template&id=836c344e&ts=true"
import script from "./AvailabilityInfo.vue?vue&type=script&lang=ts"
export * from "./AvailabilityInfo.vue?vue&type=script&lang=ts"

import "./AvailabilityInfo.vue?vue&type=style&index=0&id=836c344e&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__